import React from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../Common/BreadCrumb";
import { PAGE_TITLES } from "../../Common/constants"
import { ToastContainer, toast } from "react-toastify";

function OffersListingBreadCrumb() {
  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <BreadCrumb
            title={PAGE_TITLES.OFFERS}
            pageTitle={PAGE_TITLES.OFFERS}
            showBreadcrumb={false}
          />
          <ToastContainer position="top-center" />
        </Container>
      </div>
    </React.Fragment>
  );
}

export default OffersListingBreadCrumb;
